import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Ticket } from 'lucide-react';

export function ExtraTicketPriceCard({ config, setConfig, readOnly = false }) {
  return (
    <Card className="border-border bg-card">
      <CardHeader>
        <CardTitle className="text-lg flex items-center gap-2" style={{ fontFamily: 'Manrope' }}>
          <Ticket className="w-5 h-5 text-orange-500" />
          Prezzo Ticket Extra
        </CardTitle>
        <CardDescription>
          {readOnly ? 'Prezzo per l\'acquisto di ticket supporto aggiuntivi' : 'Configura il prezzo unitario dei ticket extra acquistabili'}
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="flex items-center gap-4">
          <div className="space-y-2 w-48">
            <Label>Prezzo per ticket (EUR)</Label>
            <Input
              data-testid="extra-ticket-price-input"
              type="number"
              min={0}
              step={0.01}
              value={config?.extra_ticket_price ?? 5}
              onChange={(e) => !readOnly && setConfig({ ...config, extra_ticket_price: parseFloat(e.target.value) || 5 })}
              disabled={readOnly}
              className={readOnly ? 'bg-muted' : ''}
            />
          </div>
          <p className="text-sm text-muted-foreground mt-6">
            Gli utenti con abbonamento attivo potranno acquistare ticket extra a €{config?.extra_ticket_price ?? 5} ciascuno.
          </p>
        </div>
      </CardContent>
    </Card>
  );
}
